/**
 * ReferralCard - Indique um Amigo (card enxuto)
 * Código + compartilhar WhatsApp + 1 linha de benefício. Números só no admin.
 */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Copy, Share2 } from 'lucide-react';
import { Button } from './ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ReferralCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/referral/my`).then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || !data.program?.active) return null;

  const copyCode = () => {
    navigator.clipboard.writeText(data.code);
    toast.success('Código copiado!');
  };

  const shareWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(data.share_text)}`, '_blank');
  };

  return (
    <div className="bg-gradient-to-r from-amber-50 to-yellow-50 border border-amber-300 rounded-xl p-4 mb-4" data-testid="referral-card">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex-1 min-w-0 text-center sm:text-left">
          <p className="font-bold text-amber-900">🎁 Indique um amigo — Oferta de Fundador</p>
          <p className="text-xs text-amber-800 mt-0.5" data-testid="referral-benefit">{data.benefit_text}</p>
          <p className="text-lg font-mono font-bold text-amber-950 mt-1 tracking-wider" data-testid="referral-code">{data.code}</p>
        </div>
        <div className="flex gap-2 justify-center sm:justify-end shrink-0">
          <Button size="sm" variant="outline" className="border-amber-400" onClick={copyCode} data-testid="referral-copy">
            <Copy className="w-4 h-4 mr-1" /> Copiar
          </Button>
          <Button size="sm" className="bg-green-600 hover:bg-green-700" onClick={shareWhatsApp} data-testid="referral-share">
            <Share2 className="w-4 h-4 mr-1" /> WhatsApp
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ReferralCard;
